import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuppliersTableComponent } from './suppliers-table/suppliers-table.component';
import { Route, RouterModule } from '@angular/router';
import { MessagesComponent } from '@vdms-hq/toast';
import {
  DataPresentationHeaderComponent,
  FormSectionComponent,
  MultipleDataPresentationComponent,
  ButtonComponent,
  UIDataSelectorComponent,
  DialogWrapperComponent,
  UIFormModule,
  UILayoutModule,
  ResultsWrapperComponent,
} from '@vdms-hq/ui';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SuppliersDataSource } from '../logic/services/suppliers-data-source';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedClientModule } from '@vdms-hq/auth';
import { SuppliersFetcher } from '../logic/services/suppliers-fetcher';
import { SuppliersCreateEditDialogComponent } from './suppliers-create-edit-dialog/suppliers-create-edit-dialog.component';
import { SelectorsModule } from '@vdms-hq/selectors';
import { UsersSelectorComponent } from '@vdms-hq/users-core';
import { DynamicFiltersModule } from '@vdms-hq/dynamic-filters';

const routes: Route[] = [
  {
    path: '',
    component: SuppliersTableComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    MessagesComponent,
    CommonModule,
    UILayoutModule,
    UIFormModule,
    ButtonComponent,
    ResultsWrapperComponent,
    MatDialogModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatTooltipModule,
    TranslateModule,
    ActivatedClientModule,
    DialogWrapperComponent,
    FormSectionComponent,
    SelectorsModule,
    UIDataSelectorComponent,
    UsersSelectorComponent,
    MultipleDataPresentationComponent,
    DataPresentationHeaderComponent,
    DynamicFiltersModule,
    SuppliersTableComponent,
    SuppliersCreateEditDialogComponent,
  ],
  exports: [SuppliersTableComponent, SuppliersCreateEditDialogComponent],
  providers: [SuppliersDataSource, SuppliersFetcher],
})
export class SuppliersEditorModule {}
